import { render, staticRenderFns } from "./ReportUpdates.vue?vue&type=template&id=61b9a2b2&scoped=true"
import script from "./ReportUpdates.vue?vue&type=script&lang=js"
export * from "./ReportUpdates.vue?vue&type=script&lang=js"
import style0 from "./ReportUpdates.vue?vue&type=style&index=0&id=61b9a2b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b9a2b2",
  null
  
)

export default component.exports